export class MaxParkingDurationHelper {
  public static resolveEffectiveMaxParkingDurationInMinutes(maxParkingDurationInMinutes: number | null | undefined,
                                                            remainingParkingQuotaInMinutes: number | null | undefined): number | null | undefined {
    let effectiveMaxParkingDurationInMinutes = maxParkingDurationInMinutes;

    if (remainingParkingQuotaInMinutes == null) {
      return effectiveMaxParkingDurationInMinutes;
    }

    const normalizedRemainingParkingQuotaInMinutes = remainingParkingQuotaInMinutes === 0
      ? -1
      : remainingParkingQuotaInMinutes;

    if (!effectiveMaxParkingDurationInMinutes) {
      effectiveMaxParkingDurationInMinutes = normalizedRemainingParkingQuotaInMinutes;
    } else {
      effectiveMaxParkingDurationInMinutes = Math.min(normalizedRemainingParkingQuotaInMinutes, effectiveMaxParkingDurationInMinutes);
    }

    return effectiveMaxParkingDurationInMinutes;
  }

  public static calculateRemainingExtensionDurationInMinutes(maxParkingDurationInMinutes: number | null | undefined,
                                                             plannedParkingDurationInMinutes: number | null | undefined): number | null {
    if (maxParkingDurationInMinutes == null || plannedParkingDurationInMinutes == null) {
      return null;
    }

    return Math.max(0, maxParkingDurationInMinutes - plannedParkingDurationInMinutes);
  }
}
